// extracted by mini-css-extract-plugin
export var actionButton = "_jp-0";
export var fileInput = "_jp-2";
export var paperclip = "_jp-1";